<span class="badge badge-cliente-analise-mercado-status-projetado-badge badge-cliente-analise-mercado-status-projetado-badge-em-negociacao"
    [title]="getTitle()">
    {{createNameStatus()}}    
</span>